import { type ReactNode, useEffect } from 'react';
import * as stylex from '@stylexjs/stylex';

// Sentinel ships dark-only by default. Miraidon's color tokens and
// sentinel's semantic layer are designed against bice (deep blue-grey)
// surfaces with purple accent — light-mode is intentionally not
// supported until a product requirement surfaces. This kept the token
// surface small and the contrast story consistent.
//
// The ThemeProvider's job is now narrow: ensure native form controls
// and scrollbars adopt the dark color-scheme hint, and expose a
// `data-theme="dark"` attribute on <html> for any future CSS that
// wants to scope itself.
//
// The legacy `mode` prop / localStorage toggle and the parallel
// `sentinel-light` / `sentinel-dark` createTheme variants have been
// removed; reintroduce them only when light-mode becomes a real
// requirement (and miraidon ships matching light tokens).

export type ThemeMode = 'dark';

const styles = stylex.create({
  root: { colorScheme: 'dark', minHeight: '100%' },
});

export interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    document.documentElement.dataset.theme = 'dark';
  }, []);
  return <div {...stylex.props(styles.root)}>{children}</div>;
}
